export const BASKET_KEYS = {
  ProductsInCart: 'productsInCart',
  CartNumbers: 'cartNumbers',
  TotalCost: 'totalCost',
};

export const HIT_PRODUCT_ID = '0';
